import config from "config/config";
import HandleApiResponse from "utils/handleApiResponse";
import { toast } from "react-toastify";
import * as moment from "moment";

const poolPrepRosterAPI = () => {
    const { handleResponse, handleError } = HandleApiResponse();

    async function getAllPoolPrepRosterDetailsAPI(values) {
        try {
          const obj = {
            method: "GET",
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
            },
          };
          const query = JSON.stringify(values);
          const res = await fetch(
            `${config.host}/panel/rp/poolPrepRoster/allPoolPrepRosters?query=${query}`,
            obj
          );
          return handleResponse(res);
        } catch (err) {
          handleError(err);
        }
      }

    
      async function getPoolPrepFindOne(values) {
            try {
              const obj = {
                method: "GET",
                credentials: "include",
                headers: {
                  "Content-Type": "application/json",
                },
              };
              const query = JSON.stringify(values);
              let res = await fetch(`${config.host}/panel/rp/poolPrepRoster/findOne?query=${query}`, obj);
              return handleResponse(res);
            } catch (err) {
              handleError(err);
            }
          } 

           async function getAllPracticesAPI(values) {
        try {
          const obj = {
            method: "GET",
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
            },
          };
          const query = JSON.stringify(values);
          const res = await fetch(
            `${config.host}/panel/rp/poolPrepRoster/getAllPracticesAPI`,
            obj
          );
          return handleResponse(res);
        } catch (err) {
          handleError(err);
        }
      }
    
          async function updatePoolPrepAPI(value) {
            try {
              const obj = {
                method: "PUT",
                credentials: "include",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(value),
              };
              let res = await fetch(`${config.host}/panel/rp/poolPrepRoster/update`, obj);
              return handleResponse(res);
            } catch (err) {
              handleError(err);
            }
          }
    
      async function createPoolPrepRosterAPI(value) {
        try {
          const obj = {
            method: "Post",
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(value),
          };
          let res = await fetch(`${config.host}/panel/rp/poolPrepRoster/create`, obj);
          return handleResponse(res);
        } catch (err) {
          handleError(err);
        }
      }

    
    return{
        getAllPoolPrepRosterDetailsAPI,
        getPoolPrepFindOne,
        updatePoolPrepAPI,
        createPoolPrepRosterAPI,
        getAllPracticesAPI
        
    }
}
export default poolPrepRosterAPI;
